export default {"src":"/_next/static/media/avatarPlus5_64.56f7cf23.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};